const ku = {
  somethingWentWrong: "ببورە هەڵەیەک ڕوویدا تکایە دواتر هەوڵبەرەوە بکەرەوە",

  login: "چوونە ژوورەوە",
  loginId: "ئایدی چوونە ژوورەوە",
  password: "وشەی تێپەڕ",

  users: "بەژداربوان",
  name: "ناو",
  phoneNumber: "ژمارەی مۆبایل",
  userId: "ئایدی هەژمار",
  email: "ئیمەیڵ",
  idNumber: "ئایدی ژمارە",
  submit: "جيبەجيکردن",
  createUser: "دروستکردنی هەژمار",
  registeredAt: "کاتی تۆمارکردن",
  days: "رۆژەکان",
  gym: "جیم",
  swim: "مەلەوانگە",

  dailyReport: "ڕاپۆرتی ڕۆژانە",
  advancedDailyReport: "ڕاپۆرتی ڕۆژانەی پێشکەوتوو",
  orders: "کافتریا",
  admin: "ئادمین",
  logout: "چوونە دەرەوە",

  admins: "ئادمینەکان",
  center: "هۆڵەکان",
  packages: "پاکێجەکان",

  id: "ئایدی",
  createdAt: "کاتی دروستکردن",
  type: "جۆر",
  features: "خزمەتگوزاریەکان",

  duration: "ماوە",
  price: "نرخ",
  discount: "داشکاندن",
  englishName: "ناوی ئینگلیزی",
  kurdishName: "ناوی کوردی",
  arabicName: "ناوی ‌عەرەبی",
  showType: "جۆری پشاندان",
  firstTime: "جاری یەکەم",
  afterFirstTime: "لە پاش جاری یەکەم",
  allTime: "هەموو کات",

  owner: "خاوەن",
  manager: "بەڕيوبەر",
  trainer: "ڕاهينەر",
  reception: "ڕیسيپشن",

  total: 'کۆی گشتی',
  distributionWithTrainer: "دابەشکردن لەگەڵ ڕاهێنەر",
  notDistributionWithTrainer: "دابەش نەکردن لەگەڵ ڕاهێنەر",

  divideBenefit: "دابەشکردنی قازانجە دارایەکەی",
  requestCourse: "کۆرس",
  cafeteria: "کافتریا",
  cafeteriaBenefit: "قازانجی کافتریا",
  expenses: "خەرجیەکان",
  cafeteriaExpenses: "خەرجی کافتریا",
  gymExpenses: "خەرجی جیم",
  date: "بەروار",

  endDate: "بەرواوری تەواوبوون",

  supplements: "تەواوکەری خۆراکی",

  newUser: "ئەندامی نوێ",
  renewSubscription: "نوێکردنەوەی ئەندامێتی",
  membershipBenefit: "داهاتی ئەندامێتی",
  reportSummary: "پوختەی ڕاپۆرت",
  advancedReportSummary: "پوختەی ڕاپۆرتی پێشکەوتوو",
  revenue: "داهات",
  profit: "قازانج",
  membershipSummary: "پوختەی ئەندامێتی",
  financeSummary: "پوختەی دارای",
  main: "سەرەکی",

  numberOrder: "ژمارەی وەسڵ",
  dashboard: "داشبۆڕد",

  memberships: "بەژداریکردن",
  activeUser: "بەژداربووی چالاک",
  expiredUser: "بەژداربوە بەسەرچوەکان",
  startDate: "بەرواری دەستپێکردن",
  start: "دەستپێک",
  end: "کۆتا",
  day: "ڕۆژ",
  username: "ناوی بەژداربوو",
  ticketNumber: "ژمارەی وەسڵ",

  offerType: "جۆری ئۆفەر",
  receptionDivideBenefit: "بڕی دابەشکردن لەگەڵ ڕیسێپشن",
  receptionDivideBenefitIQD: 'بڕی دابەشکردن لەگەڵ ڕیسێپشن دینار',
  normal: "ئاسای",
  offer: "ئۆفەری تایبەت",

  delete: "دیلیت",

  undefined: "نەزانراو",
  male: "نێر",
  female: "مێ",
  gender: "ڕەگەز",

  openingTheDoors: "کردنەوەی دەرگاکان",
  door: "دەرگای",
  reason: "هۆکار",
  employeeComing: "هاتنە ژوورەوەی کارمەندان",

  wholesalePrice: "نرخی کۆ",
  minimumsalePrice: "کەمترین نرخی فرۆشتن",
  buyPrice: "نرخی کڕین",

  balance: "باڵانس",

  numberOfGuestUsers: "ژمارەی بەژداربووی میوان",
  sellPrice: "نرخی فرۆشتن",
  realPrice: "نرخی ڕاستەقینە",

  numberOfProductInStore: "ژمارەی بەرهەم لە کۆگا",

  buy: "کڕین",
  returnOfPurchase: "گەڕاندنەوەی کڕین",
  image: "وێنە",
  select: "هەڵیبژێرە",
  sellId: "ژمارەی وەسڵ",
  note: "تێبینی",
  customers: "کڕیارەکان",
  debt: "قەرز",
  repaymentOfDebt: "گەڕاندەوەی قەرز",
  sell: "فرۆشتن",
  freeWallet: "جزدانی خۆڕای",
  money: "پارە",
  payedPrice: "پارەی دراوە",
  totalPrice: "کۆی پارە",
  productNumber: "ژمارەی بەرهەم",
  totalPreviousDebts: "کۆی قەرزەکانی پێشووی",
  totalDebts: "کۆی قەرزەکان",
  quantity: "بڕ",
  qty: 'دانە',
  print: "پرنت",
  equipments: "ئامێرەکان",
  shippingCars: "گوازەرەوەکان",
  brands: "براندەکان",
  totalPayedPrice: "کۆی دەستکەوتوو",
  remainingDebt: "کۆی قەرزی ماوە",
  brand: "براند",
  code: "کۆد",
  salary: "مووچە",
  stock: "کۆگا",
  cleaner: "پاکەرەوە",
  accountant: "ژمێریار",
  proteinSeller: "فرۆشەری پرۆتیین",
  socialMedia: "سۆشیال میدیا",
  technical: "تەکنیکاڵ",
  expense: "خەرجی",
  caffetteriaGuestUser: "میوانانی کافێتریا",
  totalSalary: "کۆی موچە",
  garage: "گەراج",
  supplementExpenses: "پڕۆتینی شکێنراو",
  bigExpenses: "خەرجیە گەورەکان",
  package: "پاکێج",
  insertLogoToImage: "دانانی لۆگۆ بۆ وێنەکان",
  proteinManager: "بەڕێوەبەری پرۆتین",
  equipmentManager: "بەڕێوەبەری ئامێرەکان",
  stockBenfitPrice: "قازانجی مەغزەن (نرخی تاک)",
  stockBenfitWholePrice: "قازانجی مەغزەن (نرخی کۆ)",
  stockBenfitBuyPrice: "کۆی مەغزەن (نرخی کڕین)",

  benfitPrice: "قازانج (نرخی تاک)",
  BenfitWholePrice: "قازانج (نرخی کۆ)",

  live: "ڕاستەوخۆ",
  purchasesHistory: "مێژووی کڕینەکان",
  balancesHistory: "مێژووی باڵانسەکان",
  usersFeedback: "فیدباکەکان",
  starRate: "ئەستێرەکان",
  feedback: "فیدباک",
  newSubscribers: "بەژداریکردنی نوێ",
  renewalOfSubscriptions: "نوێکردنەوەی بەژداریکردن",
  dollarPrice: "نرخی دۆلار",
  proteinStock: 'کۆگای پرۆتین',
  receiptsOfPayment: "پسوڵەی پێدانی پارە",
  retailPrice: 'نرخی تاک',
  subs: 'بابەتەکان',
  subject: 'بابەت',
  part: 'بەش',
  recipients: 'وەرگرەکان',
  receipts: 'پسوڵەکان',
  customs: 'گومرگ',
  carNumber: 'ژمارەی ئۆتۆمبێل',
  cost: 'تێچوو',
  expense_1: 'خەرجی لابەلا',
  creatingTransition: 'دروستکردنی گواستنەوە',
  centers: 'هۆڵەکان',
  administration: 'بەڕێوەبەری',
  brandImage: 'وێنەی براند',
  categories: 'کاتێگۆریەکان',
  jobOpportunities: 'هەلی کارەکان',
  jobOpportunitie: 'هەلی کار',
  cvs: 'سیڤیەکان',
  locaiton: 'ناونیشان',
  position: 'پێگە',
  revenueByBenefitPrice: 'داهات بەپێی (نرخی كڕین - نرخی فرۆشتن)',
  revenueByItems: 'داهات بەپێی بەرهەمی فرۆشراو',
  revenueByBuyPrice: 'داهات بەپێی (نرخی كڕین)',
  revenueWithoutExpenses: 'قازانج بەبێ خەرجی',
  publicDebt: 'قەرزی گشتی',
  ratio: 'نسبە',
  profitWithRetail: 'قازانج بەنرخی تاک',
  profitWithWholeSale: 'قازانج بەنرخی کۆ',
  gymReception: 'ڕیسیپشنی هۆڵ',
  cafeReception: 'ڕیسیپشنی کافتریا',
  gymCoach: 'ڕاهێنەری هۆڵ',
  monthlyReport: 'ڕاپۆرتی مانگانە',
  normalCourseProfit: 'قازانجی کۆرسە ئاساییەکان',
  VIPCourseProfit: 'قازانجی کۆرسە VIPەکان',
  cafeteriaProfit: 'قازانجی کافتریا',
  publicProfitAfterMamAzad: 'قازانجی گشتی دوای مام ئازاد',
  publicProfit: 'قازانجی گشتی',
  coursesReport: 'ڕاپۆرتی کۆرسەکان',
  save: 'پاشەکەوتکردن',
  loading: 'چاوەڕوانبە',
  equipmentStorage: 'کۆگای ئامێرەکان',
  licenses: 'مۆڵەتەکان',
  'attendance-time': 'کاتی ئامادەبوون',
  responsibleOfChilds: 'دایانی منداڵان',
  accountantOfAnotherCompany: 'ژمێریاری کۆمپانیاکانی دیکە',
  asudaCity: 'ئاسودە ستی',
  'asudaCity$': 'ئاسودە ستی $',
  paroshTowers: 'پەرۆش تاوەرز',
  'paroshTowers$': 'پەرۆش تاوەرز $',
  slavaCity: 'سلاڤا ستی',
  'slavaCity$': 'سلاڤا ستی $',
  mamAzad: 'مام ئازاد',
  'mamAzad$': 'مام ئازاد $',
  miniSlavaMen: 'مینی سلاڤا پیاوان',
  'miniSlavaMen$': 'مینی سلاڤا پیاوان $',
  miniSlavaWomen: 'مینی سلاڤا خانمان',
  'miniSlavaWomen$': 'مینی سلاڤا خانمان $',
  lifeTowers: 'لایف تاوەرز',
  'lifeTowers$': 'لایف تاوەرز $',
  akaFitnessProfit: 'قازانجی ئاکە فیتنس',
  akaFitnessProfit$: 'قازانجی ئاکە فتنس $',
  finalProfit: 'قازانجی گشتی',
  'price-lists': 'لیستی نرخەکان',
  'select-item': 'دیاریکردن',
  cancel: 'لابردن',
  repaymentOfDebtAkaPower: 'گەڕانەوەی قەرزی ئاکا پاوەڕ',
  debtsAkaPower: 'قەرزی ئاکا پاوەڕ',
  swimmingItems: 'بەرهەمی مەلەوانگە',
  akaFitnessSupplementsProfit: 'قازانجی ئاکە فتنس تەواوکەری خۆراکی',
  asudaSupplementsProfit: 'قازانجی ئاسودە تەواوکەری خۆراکی',
  finalPrice: 'نرخی کۆتا',
  totalRepaymentOfDebt: 'کۆی گەڕاندەوەی قەرز',
  totalPayedPriceFromSells: 'کۆی پارەی دەستکەوتو لە فرۆشتن',
  'revenue(repaymentOfDebt,payedPrice)': 'داهات (گەڕاندەوەی قەرز,پارەی دەستکەوتو لە فرۆشتنەوە)',
  ratioForDebt: 'نسبە بەپێی قەرز',
  ratioForSupplement: 'نسبە بەپێی تەواوکەری خۆراکی',
  ratioForMoney: 'نسبە بەپێی پارە',
  ratioType: 'جۆری نسبە',
  gyms: 'هۆڵەکانی لەشجوانی',

  currentMonth: 'ئەم مانگە',
  lastMonthByThisTime: 'مانگی ڕابردوو تا ئەمکاتە',
  lastMonth: 'مانگی ڕابردوو',
  allOfThem: 'هەمووی 💥',
  trainers: 'ڕاهێنەرەکان',
  thereIsNoDataToDisplay: 'هیچ داتایەک نیە بۆ پشاندان',
  sellSupplements: 'فرۆشتنی تەواوکەرە خۆراکیەکان',
  deleteMembership: 'سڕینەوەی بەژداریکردن',

  'areYouSureYouWantToDeleteThisExpense?': 'دڵنیای لە سڕینەوەی ئەم خەرجیە؟',
  deletionOfExpenses: 'سڕینەوەی خەرجی',
  'areYouSureAboutDeleting?': 'دڵنیای لە سڕینەوە؟',
  numOfNormalCourses: 'ژمارەی کۆرسە ئاساییەکان',
  numOfVIPCourses: 'ژمارەی کۆرسە VIP ەکان',

  totalPriceOfRegularCourses: 'کۆی گشتی کۆرسە ئاسایەکان',
  'totalPriceOfVIPCourses': 'کۆی گشتی کۆرسە VIP ەکان',

  'trainerProfitsFromRegularCourses': 'قازانجی گشتی ڕاهێنەر لە کۆرسە ئاساییەکان',
  'trainerProfitsFromVIPCourses': 'قازانجی گشتی ڕاهێنەر لە کۆرسە VIP ەکان',
  akaFitnessProfitFromRegularCourses: 'قازانجی ئاکە فتنس لە کۆرسە ئاساییەکان',
  'akaFitnessProfitsFromVIPCourses': 'قازانجی ئاکە فتنس لە کۆرسە VIP ەکان',
  coachGrossProfit: 'قازانجی گشتی ڕاهێنەر',
  grossProfitAkaFitness: 'قازانجی گشتی ئاکە فتنس',

  num: 'ژمارە',
  nameOfTheEmployee: 'ناوی کارمەند',
  fixedSalary: 'مووچەی جێگیر',
  courseRatio: 'نسبەی کۆرس',
  supplementRatio: 'نسبەی تەواوکەری خۆراکی',
  numOfSupplements: 'ژمارەی تەواوکەری خۆراکی',
  totalPriceOfSupplements: 'نرخی گشتیی تەواوکەری خۆراکی',
  'trainerProfit15%': 'قازانجی ڕاهێنەر 15%',
  theDollarIsGenerallyCalculatedAt: 'نرخی دۆلار بە گشتی هەژمارکراوە بە',
  courseReportSummary: 'پوختەی ڕاپۆرتی کۆرسەکان',
  salariesOfEmployees: 'مووچەی کارمەندەکان {{price}}',
  summaryOfTheDietarySupplementReport: 'پوختەی ڕاپۆرتی تەواوکەرە خۆراکیەکان',
  cafeteriaSalesReportSummary: 'پوختەی ڕاپۆرتی بەرهەمەکانی کافتریا',
  totalOfProductsWereSoldAtPriceOfDinars: 'بە کۆی گشتی {{qty}} بەرهەم فۆرشراوە بە نرخی {{price}} دینار',
  salaryNotSpecified: 'مووچە دیاری نەکراوە',
  dateNotSpecified: 'بەروار دیاری نەکراوە',
  salaryByDate: 'مووچە بەپێی بەرواری',

  increasedExpenses: 'زیادکردنی خەرجی',
  updateOfExpenses: 'تازەکردنی خەرجی',
  byPrice: 'بە نرخی',

  courseWriting: 'نوسینی کۆرس',
  courseUpdate: 'تازەکردنی کۆرس',
  changeOfParticipation: 'گۆڕینی بەژداریکردن',

  sellingOfSupplements: 'فرۆشتنی تەواوکەری خۆراکی',
  updateOfSellingSupplements: 'تازەکردنی فرۆشتنی تەواوکەری خۆراکی',
  purchaseBalance: 'زیادکردنی باڵانس',
  changeOfBalance: 'گۆڕینی باڵانس',
  openingTheDoor: 'کردنەوەی دەرگا',
  becauseOf: 'لەبەر ئەوەی',
  saleOfCafeteriaProducts: 'فرۆشتنی بەرهەمی کافتریا',

  star: 'ئەستێرە',
  in: 'لە',
  for: 'بە',

  search: 'گەڕان',

  numOfMemberships: 'ژمارەی بەژداریکردن',
  numOfThreeMonth: 'ژمارەی بەژداریکردنی سێ مانگی',
  numOfSixMonth: 'ژمارەی بەژداریکردنی شەش مانگی',
  totalPriceOfThreeMonths: 'نرخی گشتی بەژداریکردنی سێ مانگی',
  totalPriceOfSixMonths: 'نرخی گشتی بەژداریکردنی شەش مانگی',
  receptionRatioOfThreeMonths: 'نسبەی بەژداریکردنی سێ مانگی',
  receptionRatioOfSixMonths: 'نسبەی بەژداریکردنی شەش مانگی',
  akaFitnessDivideBenefitIQD: 'قازانجی ئاکا فتنس',

  receptionReportSummary: 'پوختەی ڕاپۆرتی ڕیسێپشنەکان',
  receptionsRatio: 'نسبەی ڕیسێپشنەکان',
  'thereWere{{update}}UpdatesAnd{{new}}NewSubscribersInTheReportGenerated': 'لەو ڕاپۆرتەی کە تۆمار کراوە {{new}} بەژداربووی نوێیە و {{update}} نوێکردنەوە بوە',
  membershipsRatio: 'نسبەی بەژداریکردن',

  cafeExpense: 'خەرجی کافتریا',
  gymExpense: 'خەرجی جیم',
  bigExpense: 'خەرجی گەورە',
  by: 'لەلایەن',
  cafeExpenses: 'خەرجی کافتریا',
  totalExpenses: 'کۆی خەرجیەکان',
  numOfDay: '{{num}} ڕۆژ',
  'areYouSureAboutExecutingTheAction': 'دڵنیایت لە جێبەجێکردنی ئەم کارە؟',
  youCannotChangeProducts: 'ناتوانیت بەرهەم بگۆڕیت',
  youCannotChangeProducts1: 'ناتوانیت بەرهەم بگۆڕیت ئەگەر هەڵە داخڵت کردوە تکایە گەڕانەوەی بەرهەم بکە پاشان دانەیەکی نوێ تۆمار بکەرەوە',
  player: 'یاریزان',
  returnSupplementsProductToMainStorage: 'گەڕاندنەوەی تەواوکەری خۆراکی بۆ کۆگای سەرەکی',
  others: 'زیاتر',
  playersFromOtherHalls: 'یاریزانانی هۆڵەکانی دیکە',
  'writeDownTheReasonForOpeningTheDoor': 'هۆکاری کردنەوەی دەرگا بنووسە',
  open:'کردنەوە',
  dollar: 'دۆلار',
  iqd: 'دینار',
  renew: 'نوێکردنەوە',
  userNotFoundPleaseVerifyID:'بەکار‌هێنەر نەدۆزرایەوە تکایە دڵنیا بەرەوە لە ئایدی',
  noUser:'بەکارهێنەر نیە',
  printLastMembership:'پرینتکردنی کۆتا بەژداریکردن',
  addBalance:'زیادکردنی باڵانس',
  updateFaceId:'تازەکردنەوەی فەیس ئایدی',
  updateCurrentPackage:'گۆڕینی پاکێج',
  advancePurchase:'کڕینی پێشوەختە',
  resetMobileAccount:'ڕێستکردنی ئەکاونتی مۆبایل',
  doYouWantToRegisterFace:'دەتەوێت فەیس ئایدی وەربگریت؟',
  sendRequest:'ناردنی داواکاری',
  deleteTheLastSubscriptionAndExpireIt:'سڕینەوەی کۆتا بەژداریکردن و بەسەرچوونی',
  problemsWithTheParticipantsBalance:'بوونی کێشە لەگەڵ باڵانسی بەژداربوو',
  problemsWithFaceRecognition:'بوونی کێشە لەگەڵ ناسینەوەی ڕووخسار',
  lastSubscriptionNotIncludedInDailyReport:'کۆتا بەژداریکردن لە ڕاپۆرتی ڕۆژانە نییە',
  problemsWithMobileAccounts:'بوونی کێشە لەگەڵ هەژماری مۆبایل',
  suggestedRequest:'داواکاری پێشنیارکراو',
  orCustomRequest:'یان داواکارییەکی تایبەت',
  moreDetails:'زانیاری زیاتر',
  request:'داواکاری',
  orSuggestedRequest:'یان داواکارییەکی پێشنیارکراو',
  theSameMemberHasMultipleAccounts:'هەمان بەژداربوو هەژمارێک زیاتری هەیە',
  transferOfParticipation:'گواستنەوەی بەژداریکردن',
  send:'ناردن', 
  changeTrainerName:'گۆڕینی ناوی ڕاهێنەر',
  changeCoursePrice:'گۆڕینی نرخی کۆرس',
  deleteCourse:'سڕینەوەی کۆرس',
  deleteExpense:'سڕینەوەی خەرجی',
  changeSupplementPrice:'گۆڕینی نرخی تەواوکەری خۆراکی',
  revenueType:'جۆری داهات',
  vipLocker:'لۆکەری VIP',
  salon:'ساڵۆن',
  deleteRevenue:'سڕینەوەی داهات',
  otherRevenue:'داهاتی تر',
  timesLeft:'جاری ماوە',
  openDoor:'کردنەوەی دەرگا',
  returnSupplement:'گەڕاندنەوەی تەواوکەری خۆراکی',
  'areYouSureYouWantToResetYourMobileAccount?': 'دڵنیایت لە ڕێستکردنەوەی ئەکاونتی مۆبایل؟',
  'areYouSureYouWantUpdateFaceID?': 'دڵنیایت لە تازەکردنەوەی فەیس ئایدی؟',
  'areYouSureYouWantOpenDoor?': 'دڵنیایت لە کردنەوەی دەرگا؟',
  requests:'داواکارییەکان',
  pendingRequests:'داواکاریە چاوەڕوانکراوەکان',
  status:'دۆخ',
  pending:'چاوەڕوانکراوە',
  accepted:'پەسەندکراوە',
  rejected:'ڕەتکراوە',
  cash:'کاش',
  makeItFree:'! 😕 بیکە بە خۆڕای',
  free:'خۆڕای',
  requestedCourse:'داواکردنی کۆرس',
  captain:'کاپتن',
  updateFaceIdOf: 'تازەکردنەوەی فەیس ئایدیی',
  "Gym Door": "دەرگای جیم",
  "Main Door": "دەرگای سەرەکی",
  "Swim Door": "دەرگای مەلەوانگە",
  lastMembership: 'کۆتا بەژداریکردن',
  addSwimmingItem:'زیادکردنی بەرهەمی مەلەوانگە',
  systemStatusNormal: 'دۆخی سیستەم ئاساییە',
  systemStatus: 'دۆخی سیستەم',
  akaPowerMainServer: 'سێرڤەری سەرەکی ئاکا پاوەڕ',
  faceRecognitionMachine:'ئامێری ناسینەوەی ڕووخسار',
  abnormal: 'نائاسای',
  cafeCard: 'کارتی کافتریا',
  userNotSaveInFaceMachinePleaseTryAgain: 'بەکارهێنەر لە ئامێری ناسینەوەی ڕووخسار تۆمار نەکراوە تکایە دوبارە هەوڵ بدەوە',
  payedTypeMessage: 'تکایە لە کڕیارەکە بپرسن ئایا بە دۆلار یان دینار پارە دەدات؟',
  payedType: 'جۆری پارە',
  coach: 'ڕاهێنەر',
  profile:'پرۆفایل',
  totalMoneyReceived: 'کۆی پارەی دەستکەوتوو',
  totalAvailableMoney: 'کۆی پارەی بەردەست',
  reportSummaryNew: 'پوختەی ڕاپۆرتی نوێ',
  amountOfPaymentByCustomer: 'بڕی پارەی کڕیار',
  "physicalTherapy": "چارەسەری فیزیای",
  aFullHourPhysicalTherapySessionForPartBody: "دانیشتنێکی چارەسەری فیزیایی کاتژمێری تەواو بۆ بەشێک لە جەستە",
  fullBodyMessageOneHour: "مەساجی تەواوی جەستە بۆ ماوەی یەک کاتژمێر",
  fourPhysicalTherapy: "چوار جار چارەسەری فیزیایی یان بەشێک لە جەستە",
  addPhysicalTherapy: "زیادکردنی چارەسەری فیزیایی",
  userName: "ناوی بەکارهێنەر",
  update: "نوێکردنەوە",
  "expiryDate":"بەرواری بەسەرچوون",
  "lastMembershipDate":"کۆتا تۆماری ئەندامێتی",
  birthDate: "بەرواری لە دایک بوون",
  receipt: "پسوڵە",
  available: "بەردەست",
  usd: "دۆلار",
  dinar: "دینار",
  swimmingSales: "فرۆشتنی مەلەوانگە",
  nutritionSales: "فرۆشتنی تەواوکەری خۆراکی",
  nutrition: "تەواوکەری خۆراکی",
  cafeteriaCash: "کاشی کافتریا",
  "cafeteria-card": "کارتی کافتریا",
  discountForEmployees15: "داشکاندن ١٥% بۆ کارمەندان",
};


export default ku